import React, { Component } from 'react';
import { Card, CardText, CardImg, CardImgOverlay } from 'reactstrap';

export default class Dashboard extends Component {
    constructor(props) {
        super(props)

        this.state = {};
    }

    render() {
        return (
            <Card className="shadow-sm card-option" tag="a" onClick={this.props.onClick}>
                <CardImg src={this.props.picture} alt="" height="228px" />
                <CardImgOverlay className="h-100 d-flex flex-column align-items-start">
                    <CardText tag="h3" className="align-self-center card-title-text">{this.props.cardTitle}</CardText>
                    <CardText className="mt-auto align-self-center card-body-text">
                        {this.props.cardBody}
                    </CardText>
                </CardImgOverlay>
            </Card>
        )
    }
}